// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"17ffb187","952":"189556a0"}[chunkId] + ".chunk.js";
};